import { useTranslation } from 'react-i18next';
import { QueryCache } from 'react-query';

import { handleEleveoUserRolesErrors } from '../api/eleveoRolesQuery';
import { handleEventsErrors } from '../api/eventQuery';
import { handleIntegrationRolesErrors } from '../api/integrationRolesQuery';
import { handleConfigurationsErrors } from '../api/integrationsQuery';
import { ErrorHandlerFunction } from '../api/types';

const errorHandlers: ErrorHandlerFunction[] = [
  handleEventsErrors,
  handleConfigurationsErrors,
  handleEleveoUserRolesErrors,
  handleIntegrationRolesErrors,
];

/**
 * This is not part of public `react-query` API.
 *
 * Use only inside top level components as App or setupTests!!
 */
export const useReactQueryCache = () => {
  const { t } = useTranslation();

  return new QueryCache({
    onError: (error, query) => {
      if (query.state.data !== undefined) {
        // eslint-disable-next-line no-console -- background re-fetch failed - fail silently
        console.error(`Something went wrong: ${error} with following query: ${query.queryKey}`);
        return;
      }

      // Otherwise initial fetch failed. Show error to user.
      // eslint-disable-next-line no-restricted-syntax
      for (const errorHandler of errorHandlers) {
        if (errorHandler(query.queryKey, t)) {
          // no need to check other handlers
          break;
        }
      }
    },
  });
};
